import React from 'react';

export type ButtonCardInterface = {
  btnname: string | number;
  icon?: string;
  text: string;
  onClick?: () => void;
};

export const ButtonCard: React.FC<ButtonCardInterface> = ({ btnname, icon, onClick, text }) => {
  return (
    <button
      className={`btn-card ${btnname} flex flex-col items-center justify-start rounded-xl border border-bzblue-300 bg-white px-3 pb-4 pt-2 text-bzblue-1000 shadow-sm transition hover:-translate-y-0.5 hover:border-blue-500 hover:bg-blue-50 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-300`}
      onClick={onClick}
      type="button"
    >
      {icon && <img alt="" className="mx-auto mb-1 mt-3 size-14 object-contain sm:size-20" src={icon} />}
      <span className="m-[5px] flex min-h-[40px] flex-1 items-center justify-center text-center text-[15px] font-semibold leading-snug sm:min-h-[44px] sm:text-[17px]">
        {text}
      </span>
    </button>
  );
};
